// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3U-gz","insightsList":"newBusinessInsightsMenu_insightsList__P96BR","active":"newBusinessInsightsMenu_active__2XNCd"};